import React from 'react';
import DatePicker, {registerLocale} from "react-datepicker";
import CalendarIcon from 'react-ionicons/lib/IosCalendarOutline';
import {useTranslation} from "react-i18next";
import pt from "date-fns/locale/pt";

// CSS Files
import './styles.css';
import "react-datepicker/dist/react-datepicker.css";

registerLocale("pt", pt);

const DateTimePicker = (props) => {
   const { i18n, t } = useTranslation();
   const CustomInput = (props) => <input {...props} className={"custom-input"} readOnly={true}/>;
   const isExcludedDate = (date) => (props.excludedDates || []).some(excludedDate =>
      excludedDate instanceof Date &&
      excludedDate.getFullYear() === date.getFullYear() &&
      excludedDate.getMonth() === date.getMonth() &&
      excludedDate.getDate() === date.getDate()
   );

   return <div className={props.wrapperClasses}>
      <label className={"datepicker-label"}>
         {props.datePickerLabel}
      </label>
      <div className={"datepicker"}>
         <DatePicker
            popperPlacement={"bottom-start"}
            selected={props.date}
            customInput={<CustomInput/>}
            onChange={props.onChange}
            dayClassName={(date) => isExcludedDate(date) ? "excluded-day" : undefined}
            calendarStartDay={1}
            minDate={props.minDate}
            maxDate={props.maxDate}
            excludeDates={props.excludedDates}
            showTimeSelect={props.showTimeSelect}
            timeFormat="HH:mm"
            timeIntervals={30}
            timeCaption={t("common.time")}
            locale={i18n.language}
            fixedHeight
            dateFormat={props.dateFormat}
            disabled={props.disabled}
         />
         <CalendarIcon fontSize="25px"/>
      </div>
   </div>
}

export default DateTimePicker;
